import BasicContentHorizontalTiles from './BasicContentHorizontalTiles';

export { type BasicContentHorizontalTilesProps } from './BasicContentHorizontalTiles';
export default BasicContentHorizontalTiles;
